'use client'

import { ReactNode } from 'react'

import { useSession } from 'next-auth/react'

import { useInitialUserData } from '@/shared/hooks/useInitialUserData'
import { useUsageTimeTracker } from '@/shared/hooks/useUsageTimeTracker'
import { DataProviders } from '@/shared/providers/DataProviders'
import { BootstrapErrorFallback } from '@/shared/ui/BootstrapErrorFallback'
import { BootstrapLoadingOverlay } from '@/shared/ui/BootstrapLoadingOverlay'

interface AuthenticatedBootstrapProps {
  children: ReactNode
}

export function AuthenticatedBootstrap({ children }: AuthenticatedBootstrapProps) {
  const { status } = useSession()
  const { data: initialData, isLoading, isError, fetchStatus } =
    useInitialUserData()

  // Antes dos early returns: o hook precisa rodar em toda renderização, e o
  // aluno já está diante da aplicação durante o bootstrap. Enquanto o token não
  // existe o tempo apenas se acumula, sem ser enviado.
  useUsageTimeTracker()

  if (status === 'loading') {
    return <BootstrapLoadingOverlay />
  }

  const loadingBootstrap =
    (isLoading || fetchStatus === 'fetching') && !initialData

  if (loadingBootstrap) {
    return <BootstrapLoadingOverlay />
  }

  if (isError && !initialData) {
    return <BootstrapErrorFallback />
  }

  return (
    <DataProviders initialData={initialData ?? {}}>{children}</DataProviders>
  )
}
